import { render, staticRenderFns } from "./customerLogs.vue?vue&type=template&id=0ab813a3&scoped=true&"
import script from "./customerLogs.vue?vue&type=script&lang=js&"
export * from "./customerLogs.vue?vue&type=script&lang=js&"
import style0 from "./customerLogs.vue?vue&type=style&index=0&id=0ab813a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab813a3",
  null
  
)

export default component.exports